import { infer as Infer, z } from 'zod';

export const resetPassword = z.object({
  email: z
    .email({
      error: (iss) => (iss.input == null || iss.input === '' ? 'Email jest wymagany' : 'Niepoprawny email.'),
    })
    .toLowerCase()
    .trim(),
  authToken: z.string().nullable(),
});

export type ResetPasswordSchema = Infer<typeof resetPassword>;
